<template>
<v-stepper v-model="step">
    <v-stepper-header>
      <v-stepper-step :complete="step > 1" step="1">Pix e Boleto</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="2">Dados bancários</v-stepper-step>

    </v-stepper-header>
    <v-stepper-items>
      <!-----------------tela 1 -------------->
    <v-stepper-content step="1" class="pa-0">
    <v-card>
        <v-toolbar color="green" dark>
            <v-toolbar-title>Dados para tranferência</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <div>
              <div class="headline">{{proposta.empresa.nome_fantasia}}</div>
              <v-flex xs12 class="text-xs-left pt-2">Valor negociado: {{proposta.valor | currency({ fractionCount: 2 })}}  </v-flex>
              <v-flex xs12 class="text-xs-left pt-2">Informe as infomações para pagamento abaixo:  </v-flex>

            </div>
            <v-layout row wrap justify-space-around fill-height>
              <v-flex xs12>
                <v-text-field
                  ref="cod_barras"
                  label="Código de barras do boleto"
                  v-model="cod_barras"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
              <v-text-field
                  ref="cod_pix"
                  label="Informe um pix para pagamento"
                  v-model="cod_pix"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 class="text-xs-left pt-1 text-red">O pix deve ser enviado no formato: CNPJ: 45733761000190</v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-btn flat color="red" @click="$emit('fechar')">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn flat color="green" @click="passarTela()">Avançar</v-btn>
        </v-card-actions>
    </v-card>
    </v-stepper-content>
    <!-----------------fim tela 1------------------------->
    <v-stepper-content step="2" class="pa-0">
    <v-card>
        <v-toolbar color="green" dark>
            <v-toolbar-title>Dados para tranferência</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <div>
              <div class="headline">{{proposta.empresa.nome_fantasia}}</div>
              <v-flex xs12 class="text-xs-left pt-2">Valor negociado: {{proposta.valor  | currency({ fractionCount: 2 })}}  </v-flex>
              <v-flex xs12 class="text-xs-left pt-2">Transferência Bancária:  </v-flex>
              <v-flex xs12 class="text-xs-left pt-2 red--text">Não é obrigatório informar os dados bancários!</v-flex>

            </div>
            <v-layout row wrap justify-space-around fill-height>
              <v-flex xs12>
                <v-select
                ref="select_banco"
                v-model="selectdBanco"
                :items="bancos"
                label="Selecione o banco"
                required=false
              ></v-select>
              </v-flex>
              <v-flex xs12>
              <v-text-field
                  ref="num_agencia"
                  label="Informe a agência"
                  v-model="num_agencia"
                  required=false
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
              <v-text-field
                  ref="num_conta"
                  label="Informe o número da conta com o digito"
                  v-model="num_conta"
                  required=false
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                ref="select_conta"
                v-model="selectdConta"
                :items="tipos_conta"
                label="Selecione o tipo de conta"
                required=false
              ></v-select>
              </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-btn flat color="primary" @click="voltarTela()">Voltar</v-btn>
            <v-spacer></v-spacer>
            <v-btn flat color="green" @click="submeterProposta()">Finalizar</v-btn>
        </v-card-actions>
    </v-card>
    </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>

import { propostasDao } from '@/api'

export default {
  props: ['proposta'],
  data () {
    return {
      infoPosto: {
        endereco: {},
        representante: {}
      },
      selectOpcoes: null,
      cod_barras: null,
      cod_pix: null,
      num_agencia: null,
      num_conta: null,
      step: 1,
      selectdConta: null,
      selectdBanco: null,
      bancos: [
        'Banco Itaú Unibanco',
        'Banco do Brasil',
        'Caixa Econômica Federal',
        'Banco Bradesco',
        'Banco Santander Brasil',
        'Banrisul',
        'Banco do Nordeste',
        'Sicoob',
        'Nubank',
        'Bancon Inter',
        'Neon',
        'Next',
        'Outro'
      ],
      tipos_conta: [
        'Conta Corrente',
        'Conta Poupança',
        'Conta Conjunta',
        'Conta Salário'
      ]
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    valorTotal () {
      return this.proposta.qtd_litros * (this.proposta.valor - this.proposta.desconto)
    }
  },
  methods: {
    submeterProposta () {
      this.proposta.num_boleto = this.cod_barras
      this.proposta.chave_pix = this.cod_pix
      if (this.selectdConta !== null && this.selectdBanco !== null && this.num_conta !== null) {
        this.proposta.dados_bancarios = 'Tipo de conta: ' + this.selectdConta + ' | Banco: ' + this.selectdBanco + ' | Agência: ' + this.num_agencia + ' | Conta: ' + this.num_conta
      }
      propostasDao.submeterProposta(this.proposta, this.headers).then(response => {
        if (response.ok) {
          this.$emit('carregar')
          this.$emit('fechar')
        }
      })
      this.clearInput()
      this.step = 1
    },
    clearInput () {
      this.$refs.cod_barras.clearableCallback()
      this.$refs.cod_pix.clearableCallback()
      this.$refs.num_agencia.clearableCallback()
      this.$refs.num_conta.clearableCallback()
      this.$refs.select_conta.clearableCallback()
      this.$refs.select_banco.clearableCallback()
    },
    passarTela () {
      if (this.$refs.cod_barras !== null || this.$refs.cod_pix !== null) {
        this.step = 2
      }
    },
    voltarTela () {
      if (this.step === 2) {
        this.step = 1
      }
    }
  }
}
</script>
